"use strict";

import Backbone from "backbone";
export class AutocompleteSearch extends Backbone.View {
  static initClass() {
    this.prototype.events = {
      submit: "preventDefault",
      "select2-open": "addOpenStyles",
      "select2-close": "removeOpenStyles",
      "keyup-change": "updateMirroredQuery"
    };
    this.prototype.imagePath = "/images/nav/search_icon@1x.png";
  }
  initialize() {
    this.ui = {
      $input: this.$(".js-SiteSearch-form-input")
    };
    this.initializeSelect2();
    this.preventOverflow();
    this.exiting = false;
    this.suggestions = this.ui.$input.data("suggestions");
    if (this.suggestions) {
      $(".header--container").on("mouseenter", () => {
        if (!this.exiting) {
          this.exiting = true;
          this.showPrompt();
        }
      });
    }
    return this.ui.$input.focus(() => this.showPrompt());
  }
  maybeShowSearchPopover() {
    if (!$a.is_logged_in()) {
      return;
    }
    if (Aedu.isUsingCssV1) {
      return;
    }
    if (!($("body").attr("class").split(" ").indexOf("c-single_work") >= 0)) {
      return;
    }
    return this.onImageLoad(() => {
      return Aedu.Dismissibles.showIfAppropriate("PaperSearchPopover", () => {
        if (this.onFocusPopoverShown) {
          return;
        }
        return this.showOnLoadPopover();
      });
    });
  }
  onImageLoad(callback) {
    return $("<img />").attr("src", this.imagePath).on("load", callback);
  }
  showOnLoadPopover() {
    this.ui.$input.popover({
      template: JST["core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover_bootstrap_template"](),
      content: JST["core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover"]({
        imagePath: this.imagePath
      }),
      placement: "bottom",
      container: "body",
      html: true
    }).popover("show");
    return this.onLoadSearchPopover = new OnLoadSearchPopover({
      el: $(".js-NavSearch-bootstrapPopover"),
      popoverContainer: this.ui.$input
    });
  }
  initializeSelect2() {
    return this.ui.$input.select2({
      useExistingInput: true,
      closeOnSelect: true,
      minimumInputLength: 3,
      matcher(_term, _text) {
        return true;
      },
      delay: 250,
      dropdownCssClass: "js-SiteSearch-results SiteSearch-results bootstrap DesignSystem",
      formatResult: (result, _container, _query, _escapeMarkup) => {
        return this.formatResult(result);
      },
      formatSelection: (result, _container, _escapeMarkup) => {
        return this.redirectToResult(result);
      },
      formatNoMatches: () => {
        return this.formatNoMatches();
      },
      formatInputTooShort: () => {
        return this.formatPrompt();
      },
      formatSearching: () => {
        return this.formatSearching();
      },
      ajax: {
        url: "/ac_search",
        dataType: "json",
        quietMillis: 500,
        data(term, _page) {
          return {
            q: term,
            limit: 20
          };
        },
        results(data, _page) {
          return data;
        }
      }
    });
  }
  // The Advanced Search button is abolutely positioned, so this is
  // needed to prevent user input from overlapping with the button.
  preventOverflow() {
    if ($(".js-PremiumIconContainerHoverWrapper").length > 0) {
      return this.ui.$input.addClass("hasPremiumIcon");
    }
  }
  addOpenStyles() {
    this.$el.addClass("SiteSearch--open");
    return this.addDropdownArrow();
  }
  removeOpenStyles() {
    this.$el.removeClass("SiteSearch--open");
    return this.removeDropdownArrow();
  }
  redirectToResult(result) {
    $a.track_single_request({
      typeahead_hit: true
    });
    if (result.type === "Query") {
      return this.$el.submit();
    } else {
      return window.location.href = result.entity_url;
    }
  }
  formatResult(result) {
    this.addViewAllButton();
    return JST["core_post_webpack/sitewide_business_elements/navbar/templates/search_result"]({
      result
    });
  }
  formatPrompt() {
    if (this.suggestions) {
      const links = this.suggestions.map(query => `<a href="/search?q=${encodeURIComponent(query)}">${query}</a>`);
      this.removeViewAllButton();
      return `<div style='display: flex; flex-direction: column; align-items: start; gap: 8px; padding: 16px;'>
        <span>Looking for something else?</span>
        ${links.join("")}
      </div>`;
    }
    return this.formatStatusMessage("Type to search for Papers, People, Research&nbsp;Interests, Universities, Videos,&nbsp;and&nbsp;Courses");
  }
  formatNoMatches() {
    return this.formatStatusMessage('<i class="fa fa-warning"></i>&nbsp;&nbsp;No matches found');
  }
  formatSearching() {
    return this.formatStatusMessage('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Searching...');
  }
  formatStatusMessage(msg) {
    this.removeViewAllButton();
    return `<div class='header--search-text u-taCenter u-p8x'>${msg}</div>`;
  }
  preventDefault(e) {
    if (!e.isTrigger) {
      return e.preventDefault();
    }
  }
  showPrompt() {
    this.ui.$input.select2("open");
    this.onFocusPopoverShown = true;
    return this.onLoadSearchPopover != null ? this.onLoadSearchPopover.hide() : void 0;
  }
  addDropdownArrow() {
    return $(".js-SiteSearch-results").append('<div class="js-SiteSearch-dropdownArrow DropdownArrow"></div>');
  }
  removeDropdownArrow() {
    return $(".js-SiteSearch-dropdownArrow.DropdownArrow").remove();
  }
  addViewAllButton() {
    const dropdown = $(".js-SiteSearch-results");
    if (dropdown.find(".js-SiteSearch-results-viewAll").length > 0) {
      return;
    }
    dropdown.append(JST["core_post_webpack/sitewide_business_elements/navbar/templates/view_all_button"]());
    return dropdown.find(".js-SiteSearch-results-viewAll").click(e => {
      $(e.currentTarget).html('<i class="fa fa-spinner fa-spin"></i>');
      $("<input />").attr("type", "hidden").attr("name", "nbs").attr("value", "view").appendTo(this.$el);
      return this.$el.submit();
    });
  }
  removeViewAllButton() {
    return $(".js-SiteSearch-results-viewAll").parent().remove();
  }
  updateMirroredQuery(event) {
    const query = `Papers matching "${event.target.value}"`;
    return $(".js-Search-mirroredQuery").text(query);
  }
}
AutocompleteSearch.initClass();
window.Backbone = Backbone;
window.AutocompleteSearch = AutocompleteSearch;